import { render, staticRenderFns } from "./ArtworkFileBox.vue?vue&type=template&id=4b14bcc4&"
import script from "./ArtworkFileBox.vue?vue&type=script&lang=js&"
export * from "./ArtworkFileBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports